import * as React from 'react'

import Button from '@doordash/component-button'
import {
  Text,
  Breakpoints,
  InlineChildren,
  StackChildren,
} from '@doordash/design-language'

import MediaQuery from 'react-responsive'
import {
  CardStackChildren,
  CityName,
  ContentContainer,
  MobileCardStackChildren,
  OpportunityButton,
  SectionContainer,
  SectionContent,
  SectionImage,
  SectionTitle,
} from './styles'

type Props = {
  slug?: string
  cityState?: string
  buttonHref?: string
  cityOverride?: string
  title: string
  description: string
  buttonName: string
  imageUrl: string
  flipImage?: boolean
}

export const getCityName = (cityName, cityOverride) => {
  return cityOverride || cityName
}

export const CardContent = ({
  slug,
  cityState,
  buttonHref,
  title,
  description,
  buttonName,
  mobile,
  cityOverride,
}) => (
  <CardStackChildren city={slug} mobile={mobile}>
    <ContentContainer mobile={mobile}>
      <StackChildren size={StackChildren.Sizes.Large}>
        <CityName styles={Text.Styles.Caps16}>
          {getCityName(cityState, cityOverride)}
        </CityName>
        <SectionTitle size={Text.Sizes.S32}>{title}</SectionTitle>
        <SectionContent styles={Text.Styles.PageDescriptionBody}>
          {description}
        </SectionContent>
        <OpportunityButton
          type={Button.Types.PrimaryPill}
          href={`${buttonHref}`}
          tag="a"
          isInline
        >
          {buttonName}
        </OpportunityButton>
      </StackChildren>
    </ContentContainer>
  </CardStackChildren>
)

export const CardImage = ({ imageUrl, mobile, city }) => (
  <CardStackChildren city={city} mobile={mobile}>
    <SectionImage src={imageUrl} mobile={mobile} city={city} />
  </CardStackChildren>
)

export const DrivingOpportunitiesJobSection: React.SFC<Props> = ({
  slug,
  cityState,
  buttonHref,
  title,
  description,
  buttonName,
  imageUrl,
  flipImage,
  cityOverride,
}) => (
  <React.Fragment>
    <MediaQuery minWidth={Breakpoints.Desktop + 1}>
      <SectionContainer mobile={false} city={slug} cityOverride={cityOverride}>
        <InlineChildren
          justifyContent={InlineChildren.Justification.SpaceBetween}
          size={InlineChildren.Sizes.None}
        >
          <React.Fragment>
            {flipImage && (
              <CardImage imageUrl={imageUrl} mobile={false} city={slug} />
            )}
            <CardContent
              slug={slug}
              cityState={cityState}
              buttonHref={buttonHref}
              title={title}
              description={description}
              buttonName={buttonName}
              mobile={false}
              cityOverride={cityOverride}
            />
            {!flipImage && (
              <CardImage imageUrl={imageUrl} mobile={false} city={slug} />
            )}
          </React.Fragment>
        </InlineChildren>
      </SectionContainer>
    </MediaQuery>
    <MediaQuery maxWidth={Breakpoints.Desktop}>
      <MobileCardStackChildren cityOverride={cityOverride}>
        <SectionImage src={imageUrl} mobile={true} city={slug} />
        <ContentContainer mobile={true}>
          <StackChildren size={StackChildren.Sizes.Large}>
            <CityName styles={Text.Styles.Caps16}>
              {getCityName(cityState, cityOverride)}
            </CityName>
            <SectionTitle size={Text.Sizes.S32}>{title}</SectionTitle>
            <SectionContent styles={Text.Styles.PageDescriptionBody}>
              {description}
            </SectionContent>
            <OpportunityButton
              type={Button.Types.PrimaryPill}
              href={`${buttonHref}`}
              tag="a"
              isInline
            >
              {buttonName}
            </OpportunityButton>
          </StackChildren>
        </ContentContainer>
      </MobileCardStackChildren>
    </MediaQuery>
  </React.Fragment>
)

export default DrivingOpportunitiesJobSection
